/**
 * Fill `bytes` with cryptographically strong random values via the platform Web Crypto API. `getRandomValues`
 * is available on the browser, on Node 20+ (`globalThis.crypto`), and in React Native once the app installs a
 * `getRandomValues` polyfill at its entry — so the kernel stays runtime-agnostic and never imports `node:crypto`
 * (which does not exist in a browser/RN bundle). Fails loud if no CSPRNG is present rather than emitting a weak id.
 */
function fillRandom(bytes) {
    const wc = globalThis.crypto;
    if (wc?.getRandomValues === undefined) {
        throw new Error('uuidv7: no Web Crypto getRandomValues available on this runtime');
    }
    wc.getRandomValues(bytes);
}
/**
 * RFC 9562 UUIDv7: 48-bit big-endian millisecond timestamp + version/variant + random.
 * Time-ordered, so ids sort by creation time. Primary id convention (ADR-0010).
 */
export function uuidv7(now = Date.now()) {
    const bytes = new Uint8Array(16);
    fillRandom(bytes);
    const ts = Math.max(0, Math.floor(now));
    bytes[0] = Math.floor(ts / 2 ** 40) & 0xff;
    bytes[1] = Math.floor(ts / 2 ** 32) & 0xff;
    bytes[2] = Math.floor(ts / 2 ** 24) & 0xff;
    bytes[3] = Math.floor(ts / 2 ** 16) & 0xff;
    bytes[4] = Math.floor(ts / 2 ** 8) & 0xff;
    bytes[5] = ts & 0xff;
    bytes[6] = 0x70 | (bytes[6] & 0x0f); // version 7
    bytes[8] = 0x80 | (bytes[8] & 0x3f); // variant 10xx
    let s = '';
    for (let i = 0; i < 16; i++)
        s += bytes[i].toString(16).padStart(2, '0');
    return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`;
}
export function isUuid(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}
//# sourceMappingURL=id.js.map